import { Navbar } from './Navbar';
import { Toaster } from '../ui/sonner';
import RenewalBanner from '../billing/RenewalBanner';

export function Layout({ children }) {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <RenewalBanner />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pb-safe">
        {children}
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
